
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { USER_WIDGET_DEFINITIONS } from '@/components/admin/dashboard/user-widgets';
import { toast } from '@/hooks/use-toast';

export function useWidgetInitializer() {
  useEffect(() => {
    const initializeFinancialResultWidget = async () => {
      try {
        // Check if financial-result widget exists in database
        const { data, error } = await supabase
          .from('widget_definitions')
          .select('id, title')
          .eq('id', 'financial-result')
          .maybeSingle();
        
        if (error) {
          console.error('Error checking for financial-result widget:', error);
          return;
        }
        
        // If financial-result widget doesn't exist, add it
        if (!data) {
          console.log('Financial Result widget not found in database, adding it...');
          
          // Find the widget in static definitions
          const financialResultWidget = USER_WIDGET_DEFINITIONS.find(w => w.id === 'financial-result');
          
          if (!financialResultWidget) {
            console.error('Financial Result widget not found in static definitions');
            return;
          }
          
          // Insert the widget into the database
          const { error: insertError } = await supabase
            .from('widget_definitions')
            .insert({
              id: financialResultWidget.id,
              title: financialResultWidget.title,
              description: financialResultWidget.description,
              default_size: financialResultWidget.defaultSize,
              chart_type: financialResultWidget.chartType,
              dashboard_type: financialResultWidget.dashboardType,
              query_name: financialResultWidget.queryName,
              data_fields: financialResultWidget.dataFields,
              is_active: financialResultWidget.isActive
            });
          
          if (insertError) {
            console.error('Error inserting financial-result widget:', insertError);
            return;
          }
          
          console.log('Financial Result widget added successfully');
        } else {
          console.log('Financial Result widget already exists in database:', data);
        }
      } catch (err) {
        console.error('Error in initializeFinancialResultWidget:', err);
      }
    };
    
    initializeFinancialResultWidget();
  }, []);
}
